import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import Blamable            from '@/models/traits/Blamable';
import { Addable }         from '@widesk-core/decorators/addable';
import { Editable }        from '@widesk-core/decorators/editable';
import { Timestampable }   from '@widesk-core/decorators/timestampable';

@doc.urnResource('partner')
@doc.path('/partners/{?id}')
@doc.addable
@doc.editable
@doc.timestampable
abstract class AbstractPartnerModel extends Blamable(WebsiteServiceModel) {
	declare protected _tsFilters: {
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'label': id;
		'search': string;
	};

	declare private _tsSorts: {
		id: string;
		label: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.string declare label: string;
	@doc.string declare link: string;
}

interface AbstractPartnerModel extends Addable, Editable, Timestampable {}

export default AbstractPartnerModel;
